<div class="card" style="height: auto !important">
  <div class="card-header flex justify-between items-center">
    <h3 class="card-title">Rep List</h3>
  </div>

  <!-- Reports Controls Section - Improved Layout -->
  <div
    class="p-4 grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-black dark:text-white border-b border-gray-200 dark:border-gray-700">
    <!-- Excel Reports Section -->
    <div class="space-y-2">
      <h4 class="font-medium">Excel Reports:</h4>
      <div class="flex flex-col space-y-2">
        <div class="flex items-center space-x-2">
          <label class="w-24">Report Type:</label>
          <kendo-dropdownlist class="w-48" [data]="excelRepReports" textField="reportName" valueField="repReportId"
            name="excelReportSelector" scrollable="none" [(ngModel)]="excelReportSelection"
            (valueChange)="excelReportValueChange()">
          </kendo-dropdownlist>
        </div>

        <div *ngIf="showExcelActiveCheckbox" class="flex items-center space-x-2">
          <label class="w-24">Active Only:</label>
          <input type="checkbox" name="excelShowActiveCb" [(ngModel)]="excelShowActive" kendoCheckBox />
        </div>

        <div *ngIf="showExcelFirmDropdown" class="flex items-center space-x-2">
          <label class="w-24">Firm Type:</label>
          <kendo-dropdownlist class="w-48" [data]="repState.firmTypeList" textField="firmTypeDescription"
            valueField="firmTypeID" [(ngModel)]="excelFirmSelection">
          </kendo-dropdownlist>
        </div>

        <div class="flex items-center pt-1">
          <button class="text-blue-600 hover:bg-blue-50 px-3 py-1 rounded-md" kendoButton look="flat" type="button"
            (click)="loadExcelReport()">
            <ng-icon name="heroDocument" class="mr-1"></ng-icon> Download Excel
          </button>
        </div>
      </div>
    </div>

    <!-- PDF Reports Section -->
    <div class="space-y-2">
      <h4 class="font-medium">PDF Reports:</h4>
      <div class="flex flex-col space-y-2">
        <div class="flex items-center space-x-2">
          <label class="w-24">Report Type:</label>
          <kendo-dropdownlist class="w-48" [data]="pdfRepReports" textField="reportName" valueField="repReportId"
            name="pdfReportSelector" [(ngModel)]="pdfReportSelection" (valueChange)="pdfReportValueChange()">
          </kendo-dropdownlist>
        </div>

        <div *ngIf="showPdfActiveCheckbox" class="flex items-center space-x-2">
          <label class="w-24">Active Only:</label>
          <input type="checkbox" name="pdfShowActiveCb" [(ngModel)]="pdfShowActive" kendoCheckBox />
        </div>

        <div *ngIf="showPdfRepDropdown" class="flex items-center space-x-2">
          <label class="w-24">Select Rep:</label>
          <kendo-combobox class="w-48" [data]="activeRepList" textField="shortName" valueField="repId"
            [(ngModel)]="pdfRepSelection" [filterable]="true" placeholder="Type a rep name..."
            [kendoDropDownFilter]="{ caseSensitive: false, operator: 'contains' }">
          </kendo-combobox>
        </div>

        <div *ngIf="showPdfRepMultiselect" class="flex items-center space-x-2">
          <label class="w-24">Select Reps:</label>
          <kendo-multiselect class="w-48" id="selectReps" kendoMultiSelectSummaryTag [data]="sortedRepList"
            textField="shortName" valueField="repId" [(ngModel)]="pdfRepSelectionList" [autoClose]="false"
            [popupSettings]="{ width: 300, height: 350 }" [clearButton]="false" style="min-height: 36px;"
            (close)="multiSelectValueChange()">
            <ng-template kendoMultiSelectHeaderTemplate>
              <a class="list-link" (click)="pdfRepSelectListSelectAll()">
                &nbsp;&nbsp;&nbsp;Select All
              </a>
            </ng-template>
            <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
              {{ dataItems.length }} rep(s) selected
            </ng-template>
          </kendo-multiselect>
        </div>

        <div class="flex items-center pt-1">
          <button class="text-blue-600 hover:bg-blue-50 px-3 py-1 rounded-md" kendoButton look="flat" type="button"
            (click)="loadPdfReport()">
            <ng-icon name="heroDocument" class="mr-1"></ng-icon> Download PDF
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <gd-rep-reports *ngIf="reports" [repReportId]="selectedRepReportId"
      [reportParams]="excelReportParams"></gd-rep-reports>

    <div *ngIf="!reports" class="p-3 rounded-lg shadow-sm border">
      <div class="alphabet-pager flex flex-wrap gap-2 mb-4">
        <button type="button" class="px-3 py-1 rounded-md border font-medium
                 border-gray-300 dark:border-gray-600 
                 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" [class.bg-green-500]="showAllReps"
          [class.dark:bg-green-600]="showAllReps" [class.text-white]="showAllReps"
          [class.border-green-500]="showAllReps" [class.dark:border-green-600]="showAllReps" (click)="toggleShowAll()">
          {{ showAllReps ? 'Filter by Letter' : 'Show All' }}
        </button>
        <button *ngFor="let letter of letters" class="px-2 py-1 rounded-md border border-gray-300 dark:border-gray-600 
                 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
          [class.bg-blue-500]="letter === currentLetter && !showAllReps"
          [class.dark:bg-blue-600]="letter === currentLetter && !showAllReps"
          [class.text-white]="letter === currentLetter && !showAllReps"
          [class.border-blue-500]="letter === currentLetter && !showAllReps"
          [class.dark:border-blue-600]="letter === currentLetter && !showAllReps" [class.opacity-50]="showAllReps"
          (click)="setCurrentLetter(letter)">
          {{ letter }}
        </button>
        <div class="ml-auto">
          <button type="button" (click)="onAddRepClick()" kendoButton size="medium" rounded="rounded" fillMode="solid">
            Add a Rep
          </button>
        <!-- Grid with full height -->
        <kendo-grid [kendoGridBinding]="displayedReps" [pageSize]="pageSize" [skip]="skip" [pageable]="true" [resizable]="true" [filterable]="true"
        [sortable]="true" [navigable]="true" [filter]="repState.viewRepsFilters"
        (filterChange)="repState.setViewRepsFilters($event)">
        <ng-template kendoGridToolbarTemplate>
          <button type="button" class="excelbtn" kendoGridExcelCommand icon="file-excel">
            Export to Excel
          </button>
          <div>&nbsp;</div>
        </ng-template>

        <kendo-grid-column field="lastName" title="Last Name" [filterable]="true"></kendo-grid-column>
        <kendo-grid-column field="firstName" title="First Name" [filterable]="true"></kendo-grid-column>
        <kendo-grid-column field="workPhone" title="Work Phone" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.workPhone | phone }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="email" title="Email" width="200"></kendo-grid-column>
        <kendo-grid-column field="branchNumber" title="Branch Number"></kendo-grid-column>
        <kendo-grid-column field="crdNumber" title="CRD Number"></kendo-grid-column>

        <kendo-grid-column field="hireDate" title="Hire Date" [filterable]="false">
          <ng-template kendoGridCellTemplate let-column>
            {{ column.hireDate | date : 'MM/dd/yyyy' }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="terminationDate" title="Terminated" [filterable]="false">
          <ng-template kendoGridCellTemplate let-column>
            {{ column.terminationDate | date : 'MM/dd/yyyy' }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="active" title="Active" filter="boolean" [width]="80" [resizable]="false">
          <ng-template kendoGridCellTemplate let-column>
            <input type="checkbox" [checked]="column.active" disabled />
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [hidden]="hidebyRole" [width]="50" [resizable]="false" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a style="cursor: pointer;" (click)="editRep(dataItem.repId)" title="Edit Rep">
              <ng-icon name="heroPencil"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

      <!--   <kendo-grid-column [hidden]="true" field="overrideOsjWarning" title="OSJ" filter="boolean">
          <ng-template kendoGridCellTemplate let-column>
            <input type="checkbox" (click)="changeOSJflag(column, 'overrideOsjWarning')"
              [checked]="column.overrideOsjWarning" />
          </ng-template>
        </kendo-grid-column> -->

        <kendo-grid-excel fileName="viewRepList.xlsx"></kendo-grid-excel>
      </kendo-grid>
    </div>
  </div>
</div> <!-- hideOsJ -->